module.exports = __webpack_public_path__ + "static/media/ChatLoader.35d7a9a2.svg";